var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneSolidFull1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20375 1.66869C4.05563 1.31431 3.66938 1.12681 3.30188 1.22619L3.19875 1.25431C1.9875 1.58431 0.952502 2.75806 1.25438 4.18681C1.95 7.46806 4.53188 10.0499 7.81313 10.7456C9.24375 11.0493 10.4156 10.0124 10.7456 8.80118L10.7738 8.69806C10.875 8.32868 10.6856 7.94243 10.3331 7.79618L8.50875 7.03681C8.19938 6.90743 7.84125 6.99744 7.6275 7.25806L6.90375 8.14306C5.58563 7.48868 4.52438 6.39368 3.915 5.04931L4.74375 4.37431C5.00438 4.16243 5.0925 3.80431 4.965 3.49306L4.20375 1.66869Z",
    fill: "#3F3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSolidFull1);
export default __webpack_public_path__ + "static/media/phone-solid-full 1.ea1ef1e1c2ac0f4cce364fec1469f4c8.svg";
export { ForwardRef as ReactComponent };